export enum NotificationType {
  Webhook = 1,
  EmailSubscription = 2
}
